module.exports = __webpack_public_path__ + "img/icon-save.9a8ee6d0.svg";